const MAX_INTERVAL = 5;
const POLL_INTERVAL = 4000;

export { MAX_INTERVAL, POLL_INTERVAL };
